import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { ThemeProvider as StyledThemeProvider, useTheme } from "styled-components";
import { NAMESPACE } from "./constants";
export const ThemeProvider = (props) => {
    const { children, styledTheme } = props;
    const themeFromContext = useTheme();
    const theme = props.theme || (themeFromContext && themeFromContext[NAMESPACE]);
    if (!theme) {
        throw new Error("Alchemy ThemeProvider missing theme.");
    }
    const colorScheme = props.colorScheme || theme.defaults.colorScheme;
    const accentPalette = props.accentPalette || theme.defaults.accentPalette;
    const palette = props.palette || theme.defaults.palette;
    const combinedTheme = useMemo(() => ({
        ...styledTheme,
        [NAMESPACE]: {
            ...theme,
            // Update defaults for the theme from props
            defaults: { colorScheme, palette, accentPalette }
        }
    }), [styledTheme, theme, colorScheme, palette, accentPalette]);
    return _jsx(StyledThemeProvider, { theme: combinedTheme, children: children });
};
